import { useMediaQuery } from '@mui/material'
import React, { useState } from 'react'
import { X } from 'react-feather'
import styled, { useTheme } from 'styled-components'
import { Flex } from '../Flex'
import { TextVariant, Text } from '../Text'
import ContractSelector, { type NavbarListingContract } from './ContractsSelector'

const Wrapper = styled(Flex)<{ isFading: boolean }>`
  position: relative;
  width: 100%;
  height: 48px;
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.yellow};
  justify-content: center;
  align-items: center;
  transition: opacity 0.2s ease-in-out;
  opacity: ${({ isFading }) => (isFading ? 0 : 1)};
`

const CloseButtonWrapper = styled(Flex)`
  position: absolute;
  cursor: pointer;
  margin-right: 88px;
  right: 0;
  ${({ theme }) => theme.mediaQueries.mobile} {
    margin-right: 16px;
  }
`

interface NotificationBarProps {
  closeNotification: () => void
  contracts: NavbarListingContract[]
}

const NotificationBar: React.FC<NotificationBarProps> = ({ closeNotification, contracts }) => {
  const { colors, mediaQueries } = useTheme()
  const isMobile = useMediaQuery(mediaQueries.mobile)
  const [isFading, setIsFading] = useState(false)

  return (
    <Wrapper {...{ isFading }}>
      <Flex fullWidth justifyContent="center" gap="16px" alignItems="center">
        <Text variant={isMobile ? TextVariant.TEXT_XS_BOLD : TextVariant.BODY_DEFAULT_BOLD} color={colors.black}>
          MPRO Token
        </Text>
        <ContractSelector {...{ contracts }} />
      </Flex>
      <CloseButtonWrapper
        onClick={() => {
          closeNotification()
          setIsFading(true)
        }}
      >
        <X />
      </CloseButtonWrapper>
    </Wrapper>
  )
}

export default NotificationBar
